"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = _interopRequireDefault(require("../Box"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _Text = _interopRequireDefault(require("../Text"));
var _theme = _interopRequireDefault(require("../../theme"));
var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));
var _AnimatedLoaderSquiggle = _interopRequireDefault(require("./AnimatedLoaderSquiggle"));
var _AnimatedContent = _interopRequireDefault(require("./AnimatedContent"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CopyContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "AnimatedLoader__CopyContainer",
  componentId: "sc-nt9j05-0"
})(["box-sizing:border-box;"]);
var HeadingContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "AnimatedLoader__HeadingContainer",
  componentId: "sc-nt9j05-1"
})(["text-align:center;"]);
var AnimatedLoader = function AnimatedLoader(_ref) {
  var heading = _ref.heading,
    supportingText = _ref.supportingText,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'light' : _ref$background,
    _ref$accessibilityTex = _ref.accessibilityText,
    accessibilityText = _ref$accessibilityTex === void 0 ? 'Active loading indicator' : _ref$accessibilityTex;
  /**
   * This is responsible for triggering the animation for the heading
   * and supportingText if they being animated from one array element
   * to the next.
   */
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    animationIterationId = _useState2[0],
    setAnimationIterationId = _useState2[1];
  var isLightBackground = background === 'light';
  var setAnimationIterationIdCb = _react["default"].useCallback(function () {
    setAnimationIterationId(function (iterationId) {
      return iterationId + 1;
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    size: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(8, 5, 28, 0.8)",
    position: "fixed"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    maxWidth: ['320px', '327px', '472px'],
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: isLightBackground ? 'white' : _theme["default"].indigo100,
    borderRadius: _theme["default"].borderRadiusLarge,
    "aria-live": "assertive",
    "aria-busy": "true"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    "aria-hidden": "true",
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_AnimatedLoaderSquiggle["default"], {
    squiggleColor: isLightBackground ? _theme["default"].indigo60 : 'white',
    onAnimationComplete: setAnimationIterationIdCb
  })), /*#__PURE__*/_react["default"].createElement(_VisuallyHidden["default"], null, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, accessibilityText)), /*#__PURE__*/_react["default"].createElement(CopyContainer, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    pt: "0",
    px: "spacingML",
    pb: "spacingML",
    backgroundColor: isLightBackground ? 'white' : _theme["default"].indigo100
  }, /*#__PURE__*/_react["default"].createElement(HeadingContainer, {
    mb: supportingText ? _theme["default"].spacingS : null,
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_AnimatedContent["default"], {
    iterationId: animationIterationId,
    content: heading,
    renderContent: function renderContent(contentHeading) {
      return /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
        variant: "60",
        color: isLightBackground ? 'dark' : 'white'
      }, contentHeading);
    }
  })), supportingText ? /*#__PURE__*/_react["default"].createElement(_AnimatedContent["default"], {
    iterationId: animationIterationId,
    content: supportingText,
    renderContent: function renderContent(contentSupportingText) {
      return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        variant: "100",
        color: isLightBackground ? 'light' : 'white',
        textAlign: "center"
      }, contentSupportingText);
    }
  }) : null)));
};
AnimatedLoader.propTypes = {
  accessibilityText: _propTypes["default"].string,
  background: _propTypes["default"].oneOf(['light', 'dark']),
  heading: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  supportingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)])
};
var _default = exports["default"] = AnimatedLoader;